import * as types from "../types";
import { customer, medicalCustomer } from "~api";

const {
  apiUpdateDoctorCustomer,
  apiUpdateCrmCustomer,
  apiGetCustomerApplyList,
  apiGetProjectList,
  apiUpdateDoctor,
  apiGetCustomList,
  apiGetDoctorData,
  apiGetCustomDetail,
  apiDeleteCustom,
  apiUpdateCustom,
  apiCorrectionCustom,
  apiAddCustom,
  apiUpdateCustomSalesman,
  apiGetCustomSalesman,
  apiGetCustomContacts,
  apiGetCustomVisits,
  apiExportCustom,
  apiGetCustomBusi,
  apiGetCustomCompact,
  apiGetHospitalLevel,
  apiAddConvert,
  apiUpdateConvert,
  apiDeleteConvert,
  apiGetDoctorList,
  apiGetOperatorList,
  apiSaveOperatorChange,
  apiGetCustomArchiveList,
  apiUploadFile,
  apiDeleteFile,
  apiAddCustomSalesman,
  apiDeleteCustomSalesman,
  apiGetFinallyCustom,
  apiAddFinallyCustom,
  apiEditFinallyCustom,
  apiDeleteFinallyCustom,
  apiGetRefusedCustomer,
  apiBindCode,
  apiReplyAgain,
  apiGetGovernmentData,
  apiDeleteGovernmentCus,
  apiGetBusiLine,
  apiGetInvestigationPerson,
  apiAddGovernmentCus,
  apiGetGovernmentDetail,
  apiEditGovernmentCus,
  apiGetProjectData,
  apiAddProject,
  apiDeleteProject,
  apiEditProject,
  apiDeleteProjectFollow,
  apiGetProFollowList,
  apiAddProjectFollow,
  apiEditProjectFollow,
  apiQueryTeam,
  apiGetProjectDetail,
  apiGetCustomerHold,
  apiGetCustomerTypeCategory,
  apiImportCustomer,
} = customer;

const {
  queryMedicalList,
  apiMedicalGetCustomDetail,
  apiMedicalGetDoctorList,
  apiSaveDoctorDistribute,
  apiMedicalDeleteCustom,
  apiAddMedicalCustomSalesman,
  apiUpdateMedicalCustomSalesman,
  apiGetMedicalCustomBusi,
  apiDeleteMedicalCustomSalesman,
  apiGetMedicalCustomVisits,
  apiGetMedicalCustomCompact,
  apiGetMedicalCustomContacts,
  apiAddMedicalConvert,
  apiMedicalUpdateConvert,
  apiMedicalDeleteConvert,
  apiGetMedicalCustomArchiveList,
  apiUploadMedicalFile,
  apiDeleteMedicalFile,
  apiGetMedicalFinallyCustom,
  apiAddMedicalFinallyCustom,
  apiEditMedicalFinallyCustom,
  apiDeleteMedicalFinallyCustom,
  apiGetMedicalCustomSalesman,
  apiGetMedicalProjectDetail,
} = medicalCustomer;

/*
 * sourcePart 用来区分医生客户还是普通客户
 */
export default {
  // 获取团队下拉选项
  getTeamSelect({ commit }, payload) {
    return apiQueryTeam(payload).then(res => {
      const data = res.data;
      const loop = item => {
        item.forEach(v => {
          if (v.children.length === 0) {
            delete v.children;
          } else {
            loop(v.children);
          }
        });
      };

      loop(data.children);

      const arr = {
        depth: data.depth,
        label: data.label,
        leaderUserId: data.leaderUserId,
        leaderUserName: data.leaderUserName,
        teamType: data.teamType,
        value: data.value,
        children: data.children,
      };
      commit(types.GET_TEAM_SELECT, [arr]);
    });
  },
  /**
   * 普通销售修改自己提交的审核不通过的客户申请单（医生客户类型）
   * @param {params} params
   */
  updateCrmCustomer({ commit }, payload) {
    return apiUpdateCrmCustomer(payload);
  },

  /**
   * 普通销售修改自己提交的审核不通过的客户申请单（医生客户类型）
   * @param {params} params
   */
  updateDoctorCustomer({ commit }, payload) {
    return apiUpdateDoctorCustomer(payload);
  },
  getCustomerApplyList({ commit }, payload) {
    return apiGetCustomerApplyList(payload).then(res => {
      const data = res.data;
      commit(types.GET_CUSTOM_APPLY_LIST, data);
    });
  },

  // 搜索查询或者分页查询 customList
  getCustomList({ commit }, payload) {
    return apiGetCustomList(payload)
      .then(res => {
        const data = res.data;
        commit(types.GET_CUSTOM_LIST, data);
      })
      .catch(() => {});
  },
  // 搜索查询或者分页查询 customList 医生列表
  getMedicalCustomList({ commit }, payload) {
    return queryMedicalList(payload)
      .then(res => {
        const data = res.data;
        commit(types.GET_MEDICAL_CUSTOM_LIST, data);
      })
      .catch(() => {});
  },
  // 查看客户详情
  getCustomDetail({ commit }, payload) {
    // 医生客户跟普通客户共用一套页面，但是接口走不同权限
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiMedicalGetCustomDetail({ ...otherParams })
        .then(res => {
          const data = res.data;
          commit(types.GET_CUSTOMDETAIL, data);
        })
        .catch(() => {
          commit(types.GET_CUSTOMDETAIL, {});
        });
    }
    return apiGetCustomDetail({ ...otherParams })
      .then(res => {
        const data = res.data;
        commit(types.GET_CUSTOMDETAIL, data);
      })
      .catch(() => {
        commit(types.GET_CUSTOMDETAIL, {});
      });
  },

  // 业务员列表
  getSalesmanList({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiGetMedicalCustomSalesman(otherParams)
        .then(res => {
          const data = res.data;
          commit(types.GET_CUSTOM_SALESMAN, data);
        })
        .catch(() => {});
    }

    return apiGetCustomSalesman(otherParams)
      .then(res => {
        const data = res.data;
        commit(types.GET_CUSTOM_SALESMAN, data);
      })
      .catch(() => {});
  },

  // 最终客户列表
  getFinallyCustom({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiGetMedicalFinallyCustom(otherParams)
        .then(res => {
          const data = res.data;
          commit(types.GET_FINALLY_CUSTOM, data);
        })
        .catch(() => {});
    }
    return apiGetFinallyCustom(otherParams)
      .then(res => {
        const data = res.data;
        commit(types.GET_FINALLY_CUSTOM, data);
      })
      .catch(() => {});
  },
  // 客户联系人列表
  getCustomContacts({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiGetMedicalCustomContacts(otherParams)
        .then(res => {
          const data = res.data;
          commit(types.GET_CUSTOM_CONTACTS, data);
        })
        .catch(() => {});
    }
    return apiGetCustomContacts(otherParams)
      .then(res => {
        const data = res.data;
        commit(types.GET_CUSTOM_CONTACTS, data);
      })
      .catch(() => {});
  },
  // 客户拜访记录
  getCustomVisits({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiGetMedicalCustomVisits(otherParams)
        .then(res => {
          const data = res.data;
          commit(types.GET_CUSTOM_VISITS, data);
        })
        .catch(() => {});
    }

    return apiGetCustomVisits(otherParams)
      .then(res => {
        const data = res.data;
        commit(types.GET_CUSTOM_VISITS, data);
      })
      .catch(() => {});
  },
  // 客户项目记录
  getCustomProject({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiGetMedicalProjectDetail(otherParams)
        .then(res => {
          const data = res.data;
          commit(types.GET_CUSTOM_PROJECT, data);
        })
        .catch(() => {});
    }
    return apiGetProjectDetail(otherParams)
      .then(res => {
        const data = res.data;
        commit(types.GET_CUSTOM_PROJECT, data);
      })
      .catch(() => {});
  },
  // 新增客户
  addCustom({ commit }, payload) {
    return apiAddCustom(payload);
  },
  // 编辑客户
  updateCustom({ commit }, payload) {
    return apiUpdateCustom(payload);
  },
  // 修正客户
  correctionCustom({ commit }, payload) {
    return apiCorrectionCustom(payload);
  },
  // 删除客户
  deleteCustom({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiMedicalDeleteCustom(otherParams);
    }
    return apiDeleteCustom(otherParams);
  },
  // 编辑医生客户
  updateDoctor({ commit }, payload) {
    return apiUpdateDoctor(payload);
  },
  // 获取客户详情内部的项目列表
  getProjectList({ commit }, payload) {
    return apiGetProjectList(payload)
      .then(res => {
        const data = res.data.data;
        commit(types.GET_PROJECT_LIST, data);
      })
      .catch(() => {});
  },

  // 更新对接客户的业务员
  updateCustomSalesman({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiUpdateMedicalCustomSalesman(otherParams);
    }
    return apiUpdateCustomSalesman(otherParams);
  },
  // 导出
  exportCustom({ commit }, payload) {
    return apiExportCustom(payload.params, payload.config);
  },
  // 客户商机列表
  getCustomBusi({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiGetMedicalCustomBusi(otherParams)
        .then(res => {
          const data = res.data;
          commit(types.GET_CUSTOM_BUSI, data);
        })
        .catch(() => {});
    }
    return apiGetCustomBusi(otherParams)
      .then(res => {
        const data = res.data;
        commit(types.GET_CUSTOM_BUSI, data);
      })
      .catch(() => {});
  },
  // 客户合同列表
  getCustomCompact({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiGetMedicalCustomCompact(otherParams)
        .then(res => {
          const data = res.data;
          commit(types.GET_CUSTOM_COMPACT, data);
        })
        .catch(() => {});
    }

    return apiGetCustomCompact(otherParams)
      .then(res => {
        const data = res.data;
        commit(types.GET_CUSTOM_COMPACT, data);
      })
      .catch(() => {});
  },
  // 医院等级列表
  getHospitalLevelType({ commit }, payload) {
    return apiGetHospitalLevel(payload)
      .then(res => {
        const data = res.data;
        commit(types.GET_CUSTOM_HOSPITAL_LEVEL, data);
      })
      .catch(() => {});
  },
  // 医院等级列表
  getCustomerFollowUp({ commit }, payload) {
    return apiGetHospitalLevel(payload)
      .then(res => {
        const data = res.data;
        commit(types.GET_CUSTOM_FOLLOW_UP, data);
      })
      .catch(() => {});
  },
  // 添加联系人
  addConvert({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiAddMedicalConvert(otherParams);
    }
    return apiAddConvert(otherParams);
  },
  updateConvert({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiMedicalUpdateConvert(otherParams);
    }
    return apiUpdateConvert(otherParams);
  },
  deleteConvert({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiMedicalDeleteConvert(otherParams);
    }
    return apiDeleteConvert(otherParams);
  },
  // 分配客户-查看客户获取医生列表
  getDoctorList({ commit }, payload) {
    return apiMedicalGetDoctorList(payload)
      .then(res => {
        const data = res.data;
        commit(types.GET_DOCTOR_LIST, data);
      })
      .catch(() => {});
  },
  // 分配客户保存
  saveDoctorDistribute({ commit }, payload) {
    return apiSaveDoctorDistribute(payload);
  },
  // 获取运营人员列表
  getOperator({ commit }, payload) {
    return apiGetOperatorList(payload)
      .then(res => {
        const data = res.data;
        commit(types.GET_OPERATOR_LIST, data);
      })
      .catch(() => {});
  },
  // 保存修改运营人员
  saveOperatorChange({ commit }, payload) {
    return apiSaveOperatorChange(payload);
  },
  getCustomArchive({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiGetMedicalCustomArchiveList(otherParams)
        .then(res => {
          const data = res.data;
          commit(types.GET_CUSTOM_ARCHIVE_LIST, data);
        })
        .catch(() => {});
    }
    return apiGetCustomArchiveList(otherParams)
      .then(res => {
        const data = res.data;
        commit(types.GET_CUSTOM_ARCHIVE_LIST, data);
      })
      .catch(() => {});
  },
  uploadFile({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload.params;
    if (sourcePart === "medicalCus") {
      return apiUploadMedicalFile(payload.params, payload.config);
    }
    return apiUploadFile(payload.params, payload.config);
  },
  deleteFile({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiDeleteMedicalFile(otherParams);
    }
    return apiDeleteFile(otherParams);
  },
  addCustomSalesman({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiAddMedicalCustomSalesman(otherParams);
    }
    return apiAddCustomSalesman(otherParams);
  },
  deleteCustomSalesman({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiDeleteMedicalCustomSalesman(otherParams);
    }
    return apiDeleteCustomSalesman(otherParams);
  },
  addFinallyCustom({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiAddMedicalFinallyCustom(otherParams);
    }
    return apiAddFinallyCustom(otherParams);
  },
  editFinallyCustom({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiEditMedicalFinallyCustom(otherParams);
    }
    return apiEditFinallyCustom(otherParams);
  },
  deleteFinallyCus({ commit }, payload) {
    const { sourcePart, ...otherParams } = payload;
    if (sourcePart === "medicalCus") {
      return apiDeleteMedicalFinallyCustom(otherParams);
    }
    return apiDeleteFinallyCustom(otherParams);
  },
  getRefusedCustomer({ commit }, payload) {
    return apiGetRefusedCustomer(payload)
      .then(res => {
        const data = res.data;
        commit(types.GET_REFUSED_CUSTOMER, data);
      })
      .catch(() => {});
  },
  // 医生列表
  getCrmDoctorList({ commit }, payload) {
    return apiGetDoctorData(payload)
      .then(res => {
        const data = res.data;
        commit(types.GET_DOCTOR_ARCHIVE_LIST, data);
      })
      .catch(() => {});
  },

  bindCode({ commit }, payload) {
    return apiBindCode(payload);
  },
  replyAgain({ commit }, payload) {
    return apiReplyAgain(payload);
  },
  getGovernmentData({ commit }, payload) {
    return apiGetGovernmentData(payload)
      .then(res => {
        const data = res.data;
        commit(types.GET_GOVERNMENT_DATA, data);
      })
      .catch(() => {});
  },
  deleteGovernmentCus({ commit }, payload) {
    return apiDeleteGovernmentCus(payload);
  },
  addGovernmentCus({ commit }, payload) {
    return apiAddGovernmentCus(payload);
  },
  getBusiLine({ commit }, payload) {
    return apiGetBusiLine(payload)
      .then(res => {
        const data = res.data;
        commit(types.GET_GOVERNMENT_BUSILINE, data);
      })
      .catch(() => {});
  },
  getInvestigationPerson({ commit }, payload) {
    return apiGetInvestigationPerson(payload)
      .then(res => {
        const data = res.data;
        commit(types.GET_INVESTIGATION_PERSON, data);
      })
      .catch(() => {});
  },
  getGovernmentDetail({ commit }, payload) {
    return apiGetGovernmentDetail(payload)
      .then(res => {
        const data = res.data;
        commit(types.GET_GOVERNMENT_DETAIL, data);
      })
      .catch(() => {
        commit(types.GET_GOVERNMENT_DETAIL, {});
      });
  },
  editGovernmentCus({ commit }, payload) {
    return apiEditGovernmentCus(payload);
  },
  getProjectData({ commit }, payload) {
    return apiGetProjectData(payload)
      .then(res => {
        const data = res.data;
        commit(types.GET_PROJECT_DATA, data);
      })
      .catch(() => {});
  },
  addProject({ commit }, payload) {
    return apiAddProject(payload);
  },
  deleteProject({ commit }, payload) {
    return apiDeleteProject(payload);
  },
  editProject({ commit }, payload) {
    return apiEditProject(payload);
  },
  deleteProjectFollow({ commit }, payload) {
    return apiDeleteProjectFollow(payload);
  },
  getProFollowList({ commit }, payload) {
    return apiGetProFollowList(payload)
      .then(res => {
        const data = res.data;
        commit(types.GET_PROFOLLOW_DATA, data);
      })
      .catch(() => {});
  },
  addProjectFollow({ commit }, payload) {
    return apiAddProjectFollow(payload);
  },
  editProjectFollow({ commit }, payload) {
    return apiEditProjectFollow(payload);
  },
  getCustomerHold({ commit }, payload) {
    return apiGetCustomerHold(payload)
      .then(res => {
        const data = res.data;
        commit(types.GET_CUSTOMER_HOLD, data);
      })
      .catch(() => {});
  },
  // 获取客户类型 非医生
  getCustomType({ commit }, payload) {
    return apiGetCustomerTypeCategory({ pageNumber: 1, pageSize: 100 })
      .then(res => {
        commit(types.GET_CUSTOM_TYPE_NO_DOC, res.data.results);
      })
      .catch(() => {});
  },
  // 回款导入
  upload({ commit }, payload) {
    return apiImportCustomer(payload.params, payload.config);
  },
};
